namespace RioERP.Masters {
    export class TaxCategoryColumns {
        static columnsKey = 'Masters .TaxCategory';
    }
}
